// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"7727326e","510":"c6018d88"}[chunkId] + ".chunk.css";
};